import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IdState {
  ids: string[]; // Type of the IDs
}
// Retrieve the initial state from sessionStorage if available
const loadInitialState = (): IdState => {
  const storedIds = sessionStorage.getItem('ids');
  return storedIds ? { ids: JSON.parse(storedIds) } : { ids: [] };
};
const initialState: IdState = loadInitialState();
const idSlice = createSlice({
  name: 'idStore',
  initialState,
  reducers: {
    addId: (state, action: PayloadAction<string>) => {
      if (!state.ids.includes(action.payload)) {
        state.ids.push(action.payload);
        sessionStorage.setItem('ids', JSON.stringify(state.ids)); 
      }
    },
    removeId: (state, action: PayloadAction<string>) => {
      state.ids = state.ids.filter(id => id !== action.payload);
      sessionStorage.setItem('ids', JSON.stringify(state.ids)); 
    },
    clearIds: (state) => {
      state.ids = [];
      sessionStorage.removeItem('ids'); 
    },
    setIds: (state, action: PayloadAction<string[]>) => {
      state.ids = action.payload;
      sessionStorage.setItem('ids', JSON.stringify(state.ids)); 
    }
  },
});

export const { addId, removeId, clearIds, setIds } = idSlice.actions;
export default idSlice.reducer;
